<template>
	<taskyType :type="4" />
</template>

<script>
import taskyType from '@/components/taskyType/taskyType';
export default {
	components: {
		taskyType
	}
};
</script>

<style></style>
